import setReduxAction from 'modules/redux/actions/set/index.js'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str/index.js'
import {
  STRIPE_KEY,
  STRIPE_PATH
} from 'modules/stripe/redux/constants/index.js'

export function updateShouldFocusCardElementStripeAction (value) {
  const key = STRIPE_KEY.SHOULD_FOCUS_CARD_ELEMENT
  return setReduxAction({
    type: getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.UPDATE,
      key
    ),
    payload: {
      path: STRIPE_PATH[key],
      value
    }
  })
}
